// Constants
import { ENVIRONMENT, DEFAULT_UNIVERSE_URL } from "../constants/url";

const ENV = (process.env.NEXT_PUBLIC_ENV as ENVIRONMENT) || ENVIRONMENT.PROD;

const UNIVERSE_API_URL = process.env.NEXT_PUBLIC_UNIVERSE_API_URL as string;

export const universeBaseURL = UNIVERSE_API_URL || DEFAULT_UNIVERSE_URL[ENV];
